'use strict';

customerZone

/**
 * Indicates that a table can be transformed into a list of cards if required.
 *
 * This directive merely adds the header values to the table cells, so they
 * can be cardified using css.
 */
.directive('cardTable', ['utils', function(utils){

    return {
        compile: function(elem){
            elem.addClass('cardable-table');

            var headers = elem.find('> thead > tr > th');

            elem.find('> tbody > tr').each(function(){
                var $row = $(this);
                var cells = $row.children('td');
                for (var i=0; i < cells.length; i++){
                    if (i < headers.length)
                        $(cells[i]).attr('header-label', utils.translate(headers[i].innerHTML));
                }
            });
        }
    };
}]);
